import { MutableRefObject, useCallback } from "react";
import { getAmazonRestrictedAllAsins, getAmazonListingsByAsins } from "api/amazon";

// Returns a list of results and marks each result with two extra values - restrictions & listings
// marked according to the mysql tables amazon_items_restrictions and amazon_listings
// TODO: I feel like I should either rename this function (to show that it also includes listings now) or split it into two
// TODO: Will there ever be a case where we want just restrictions or listings, not both? If so, I should definitely split the function.
const useRestrictionsAmazon = () => {

    const postFetchFn = useCallback(async (result: any, refForAbortSignal?: MutableRefObject<any>) => {
        const controller = new AbortController();
        if (refForAbortSignal) refForAbortSignal.current = controller
        const asins = result?.rows?.map((row: any) => row?.asin) || [] // Get all asins from the current page
        if (asins?.length) {
            const tt = Date.now()
            // Get and set restrictions data
            const data = await getAmazonRestrictedAllAsins(asins, controller)
            const map = new Map()
            data.forEach((a: any) => {
                const old = map.get(a.asin)
                if (!old) {
                    map.set(a.asin, [a])
                } else {
                    map.set(a.asin, [...old, a])
                }
            })
            // Get and set listings data
            const allListings = await getAmazonListingsByAsins(asins, controller)
            const listingsMap = new Map();
            allListings.forEach((a: any) => {
                const old = listingsMap.get(a.asin);
                if (!old) {
                    listingsMap.set(a.asin, [a])
                } else {
                    listingsMap.set(a.asin, [...old, a])
                }
            })
            result = { // Creates a new result object
                ...result, // Based on the result param, using the spread operator
                rows: result.rows.map((row: any) => ({ // Adds a new array to the row
                    ...row, // For each row, a new object is created. It contains all existing properties from the original row using ...row
                    restrictions: map.get(row.asin),  // Then it adds the restrictions property with restriction data for a certain asin
                    listings: listingsMap.get(row.asin) // Add the listings property.
                }))
            }
        }
        return result
    }, [])


    return {
        postFetchFn
    }
}


export default useRestrictionsAmazon
